export default "__VITE_ASSET__C6IJ0uRh__"